const state = {
  corporateSignatures: []
};

export default state;
